module.exports = __webpack_public_path__ + "static/image/service/m/ceo@3x.jpg?d6306134";